import { useShopTime } from '@modules/Timezone/providers/ShopTimeProvider';
import { useAnalyticsParams } from '../../modules/AnalyticsParams/hooks/useAnalyticsParams';
import { createAnalyticsChartData } from '../../pages/AnalyticsReport/hooks/utils/createAnalyticsChartData';
import { formatChartLabel } from '../../pages/AnalyticsReport/hooks/utils/formartChartLabel';
import { formatChartValue } from '../../pages/AnalyticsReport/hooks/utils/formatChartValue';
import { useAnalyticsContext } from '../../providers/AnalyticsProvider';
import { useAnalyticsReportQuery } from '../../queries/useAnalyticsReportQuery';
import { extractPrimitiveValue } from '../../utils/extractPrimitiveValue';
import { useAnalyticsCardLegend } from '../useAnalyticsCardLegend';
import { useAnalyticsQueryParams } from '../useAnalyticsQueryParams';
import { useReportLink } from '../useReportLink';
const reportId = 'average_order_value';
export const useAverageOrderValueReportCard = () => {
    const { isLoading: isReportDefinitionLoading, getReportDefinition } = useAnalyticsContext();
    const analyticsQueryParams = useAnalyticsQueryParams();
    const { groupBy, dateRange } = useAnalyticsParams();
    const { toShopTime } = useShopTime();
    const reportLink = useReportLink(reportId);
    const legend = useAnalyticsCardLegend();
    const timezonedDateRange = [
        toShopTime(dateRange.value.dates[0]),
        toShopTime(dateRange.value.dates[1]),
    ];
    const reportDefinition = getReportDefinition(reportId);
    const { analyticsReportQuery } = useAnalyticsReportQuery([{ id: reportId }, analyticsQueryParams]);
    const activeColumn = reportDefinition?.columns.find((column) => column.key === reportDefinition?.yAxisDefaultValue);
    const reportData = analyticsReportQuery?.data;
    const getValue = () => {
        if (!reportData || !activeColumn)
            return 0;
        const summaryValue = reportData.report.summary[activeColumn.key];
        const primitiveValue = extractPrimitiveValue(summaryValue);
        return typeof primitiveValue === 'number' ? primitiveValue : 0;
    };
    return {
        isLoading: isReportDefinitionLoading || analyticsReportQuery.isLoading,
        type: 'lineChart',
        emptyMessage: 'No data found in this date range',
        header: {
            label: reportDefinition?.name || '',
            tooltip: activeColumn?.tooltip,
        },
        reportLink,
        value: getValue(),
        data: createAnalyticsChartData({
            reportData,
            activeSeries: activeColumn?.key || '',
        }),
        legend,
        formatValue: (value) => formatChartValue(value, activeColumn?.type),
        formatXAxis: (value) => formatChartLabel({
            value,
            type: reportDefinition?.columns[0].type || 'number',
            timezonedDateRange,
            precision: groupBy.value.value,
        }),
    };
};
